import { IsJsonString } from "@/utils/json";
import { formatDateTime } from "@/utils";
import store from "@/store/store";
//  projetsConfig,
//  internalBoard

// Affichage des commentaires selon demande standard ou custom
// -> comments = liste des commentaires de la carte (card.actions où type = commentCard)
// => Retourne une liste d'objets de commentaire
function ParseComments(comments) {
  // Liste de retour
  var _comments = [];

  comments.forEach(d => {
    // Cas d'un commentaire custom = demande créée par l'interface
    if (IsJsonString(d.data.text)) {
      _comments.push(JSON.parse(d.data.text));
    }
    // Cas d'un commentaire Trello standard
    else {
      const user = store.state.trelloConfig.userConfig.find(u => u.idTrello == d.memberCreator.id);
      var _comment = {
        author: {
          idSdc: user ? user.id : "",
          fullName: d.memberCreator.fullName,
          initiales: d.memberCreator.initials,
          admin: user ? true : false
        },
        date: d.date.slice(0, 10),
        hour: d.date.slice(11, 16),
        text: d.data.text
      };

      _comments.push(_comment);
    }
  });

  return _comments;
}


// Créer un commentaire au bon format
// -> userSdcGuid = GUID de l'utilisateur
// -> userFullName = Prénom + Nom
// -> userInitiales = Initiales de l'utilisateur
// -> text = Commentaire / Message du tchat
// => Retourne le commentaire au format string
function CreateComment(userSdcGuid, userFullName, userInitiales, text) {

  var today = new Date();
  var d = String(today.getDate()).padStart(2, '0');
  var m = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var y = today.getFullYear();

  var hour = today.getHours() < 10 ? "0" + today.getHours() : today.getHours();
  var min = today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes();
  var sec = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();


  var comment = {
    author: {
      idSdc: userSdcGuid,
      fullName: userFullName,
      initiales: userInitiales
    },
    date: y + "-" + m + "-" + d,
    hour: hour + ":" + min + ":" + sec,
    text: text
  };

  return JSON.stringify(comment);
}


// On ajoute à la carte, les champs calculés
function ComputeCustomFields(card) {
  let newCard = Object.assign({}, card);
  newCard.priorite = getTypePriorite(card.labels);
  newCard.priorityLevel = newCard.priorite ? newCard.priorite.priorite : 4
  newCard.demandeType = getTypeDemande(card.labels);
  // On ajoute la liste des id SDC, des membres de la carte
  newCard.membersSdc = card.idMembers.map(id => {
    const user = store.state.trelloConfig.userConfig.find(e => e.idTrello == id)
    if (user)
      return user.id
    return ""
  })
  newCard.listType = getCardListType(card)

  newCard = ParseCustomDesc(newCard);
  return newCard;
}

// Récupération du type de la demande (Initial, Bug, Amélioration ou Divers)
function getTypeDemande(cardLabels) {
  let res = null;
  cardLabels.forEach(l => {
    let _d = store.state.trelloConfig.typeDemandeConfig.find(t => t.name == l.name && t.color == l.color);

    if (_d != undefined) {
      res = _d
    }
  });
  return res;
}

// Récupération de la priorité ajustée de la demande (Bloquant, Majeur ou Mineur)
// Ajusté par un membre du service informatique
function getTypePriorite(cardLabels) {
  let res = null

  cardLabels.forEach(l => {
    let _p = store.state.trelloConfig.prioriteConfig.find(t => t.label == l.name && t.color == l.color);

    if (_p != undefined) {
      res = _p
    }
  });

  return res;
}

// Récupère le type de liste à laquelle la carte appartient (todo/doing/test/done)
function getCardListType(card) {
  const idBoard = card.idBoard;
  try {
    if (store.state.trelloConfig.boardConfig[idBoard].todoLists.indexOf(card.idList) !== -1) { // Si la carte fait partie des listes "todo"
      return "todo"
    }
    if (store.state.trelloConfig.boardConfig[idBoard].doingLists.indexOf(card.idList) !== -1) { // Si la carte fait partie des listes "doing"
      return "doing"
    }
    if (store.state.trelloConfig.boardConfig[idBoard].testLists.indexOf(card.idList) !== -1) { // Si la carte fait partie des listes "test"
      return "test"
    }
    if (store.state.trelloConfig.boardConfig[idBoard].doneLists.indexOf(card.idList) !== -1) { // Si la carte fait partie des listes "done"
      return "done"
    }
  } catch (e) {
    console.log("error on card:", card);
  }
  return ""
}

// Ajoute les informations parsées s'il s'agit d'une demande interne
function ParseCustomDesc(card) {
  let newCard = Object.assign({}, card);

  if (IsJsonString(newCard.desc)) {
    let descObj = JSON.parse(newCard.desc);
    descObj.priorite = store.state.trelloConfig.prioriteConfig.find(d => d.priorite == descObj.priorite);
    descObj.type = "custom"

    newCard.initialDesc = descObj;
    newCard.desc = descObj.description || "";
    newCard.creator = descObj.demandeur;
    newCard.custom = true;
    newCard.membersSdc.push(descObj.demandeur.sdcGuid);
  }
  else {
    newCard.initialDesc = {
      demandeur: {},
      description: "",
      priorite: {
        priorite: 0,
        label: "",
        color: ""
      },
      projet: "",
      type: "standard"
    }
    newCard.custom = false
    if (newCard.actions && newCard.actions.length > 0) {// Si on a inclus les actions
      const creationAction = newCard.actions.find(a => a.type == "createCard");
      if (creationAction) {
        // On ajoute les informations sur le créateur de la carte
        const creatorTrelloId = creationAction.idMemberCreator;
        const user = store.state.trelloConfig.userConfig.find(u => u.idTrello == creatorTrelloId);
        if (user && !newCard.custom) {
          newCard.creator = {
            fullName: user.firstName + " " + user.name,
            initiales: user.initials,
            sdcGuid: user.id
          }
        }
      }
    }
  }
  return newCard;
}


// Convertit un tableau de byte en objet web
// -> type = type de l'objet
// -> base64Array = table en question
// => Retourne un objet web
function TransformAttachment(type, base64Array) {
  var _b = atob(base64Array);
  var _arrayBytes = new Array(_b.length);

  for (var i = 0; i < _b.length; i++) {
    _arrayBytes[i] = _b.charCodeAt(i);
  }

  var buffer = new Uint8Array(_arrayBytes);

  var blobEponge = new Blob([buffer], {
    type: type
  });

  return {
    type: GetObjectType(type),
    url: URL.createObjectURL(blobEponge)
  };
}


//
//
//
//
function GetObjectType(type) {
  if (type.includes("image")) {
    return "image";
  }
  else if (type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || type == "application/vnd.ms-excel") {
    return "excel";
  }
  else if (type == "application/pdf") {
    return "pdf";
  }
  else if (type == "text/plain") {
    return "txt";
  }
  else if (type == "application/vnd.oasis.opendocument.text" || type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || type == "application/msword") {
    return "word";
  }
  else if (type == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
    return "ppt";
  }
}

function ActionToText(action, resume = true) {
  let textType = 'Indéfini'
  if (resume) {
    switch (action.type) {
      case 'addAttachmentToCard': textType = 'Pièce jointe ajoutée'; break;
      case 'addChecklistToCard': textType = 'Checklist ajoutée'; break;
      case 'addMemberToCard': textType = 'Membre ajouté au ticket'; break;
      case 'commentCard': textType = 'Commentaire ajouté'; break;
      case 'convertToCardFromCheckItem': textType = 'Création de la carte depuis une tâche'; break;
      case 'copyCard': textType = 'Carte copiée'; break;
      case 'copyCommentCard': textType = 'Commentaire copié'; break;
      case 'createCard': textType = 'Carte créée'; break;
      case 'deleteCard': textType = 'Carte supprimée'; break;
      case 'emailCard': textType = 'Email envoyé'; break;
      case 'moveCardFromBoard': textType = 'Carte déplacée depuis le tableau'; break;
      case 'moveCardToBoard': textType = 'Carte déplacée vers le tableau'; break;
      case 'removeChecklistFromCard': textType = 'Checklist supprimée'; break;
      case 'removeMemberFromCard': textType = 'Membre supprimé du ticket'; break;
      case 'updateCard': textType = 'Carte mise à jour'; break;
      case 'updateCheckItemStateOnCard': textType = 'Tâche mise à jour'; break;
      case 'updateChecklist': textType = 'Checklist mise à jour'; break;
      case 'updateMember': textType = 'Membres mis à jour'; break;
    }
  }
  return formatDateTime(new Date(action.date), true) + " - " + textType
}

export { ParseComments, CreateComment, ComputeCustomFields, TransformAttachment, GetObjectType, ActionToText };
export default { ParseComments, CreateComment, ComputeCustomFields, TransformAttachment, GetObjectType, ActionToText };



// WEBPACK FOOTER //
// ./src/utils/trelloContentHelper.js